import * as React from 'react';
import { observer } from 'mobx-react';
import { CSSTransitionGroup } from 'react-transition-group';

// Styles
const s = require('./Pages.css');

// Component
@observer
export class Pages extends React.Component<{}, {}> {
    render() {
        return (
            <CSSTransitionGroup
                component="div"
                className="pages-container"
                transitionName="slide"
                transitionAppear={true}
                transitionEnter={true}
                transitionLeave={true}
                transitionAppearTimeout={500}
                transitionEnterTimeout={500}
                transitionLeaveTimeout={500}
            >
                {this.props.children}
            </CSSTransitionGroup>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/layout/Pages.tsx